<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="CUSTOMER BESPOKE FORMULATION" >
          <template slot="actions">
            <vs-button v-can="'create-private-formulation'"  @click="onClickAddFormulationToCustomer" class="mr-4" color="primary" type="filled">Add</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="customer-private-forumation-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="name">ITS PRODUCT CODE</vs-th>
                <vs-th sort-key="contact_1">ITS PRODUCT NAME</vs-th>
                <vs-th >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].formulation_name }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip v-can="'edit-private-formulation'" text="Remove" position="left">
                        <vs-button @click.native="onClickRemoveFormulation(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
    <add-private-formulation-to-customer-pop-up ref="addPrivateFormulationToCustomerPopUp"/>
    <update-customer-site-pop-up ref="updateCustomerSitePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import AddPrivateFormulationToCustomerPopUp
    from "@/components/popups/customer/private-formuation/AddPrivateFormulationToCustomerPopUp";
  import UpdateCustomerSitePopUp from '@/components/popups/customer/sites/UpdateCustomerSitePopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerSitePopUp,
      AddPrivateFormulationToCustomerPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        await this.fetchPrivateFormulations()
      },

      async fetchPrivateFormulations() {
        await this.$vs.loading({
          container: '#customer-private-forumation-table',
          scale: 0.45
        })
        const {data} = await CustomerRepository.getCustomerPrivateFormulation(this.customerId, this.filterQuery)
        this.staff =  data.data
        this.$vs.loading.close('#customer-private-forumation-table > .con-vs-loading')
      },

      async onClickAddFormulationToCustomer () {
        await this.$refs.addPrivateFormulationToCustomerPopUp.openPopup(this.customerId)
      },
      async onClickRemoveFormulation(id) {
        await this.$vs.loading({
          container: '#customer-private-forumation-table',
          scale: 0.45
        })
        const {data} = await CustomerRepository.deletePrivateFormulationFromCustomer(id)
        this.staff =  data.data
        this.$vs.loading.close('#customer-private-forumation-table > .con-vs-loading')
        await this.fetchPrivateFormulations()
      },

      filterQueryUpdate (){
        this.fetchPrivateFormulations()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchPrivateFormulations()
      }

    },
    watch : {
      page(){
        this.fetchPrivateFormulations()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
